export const Alert = ({ message, type }) => {
    return (
        <div
            className={`${
                type === 1
                    ? "bg-green-400"
                    : type === 0
                    ? "bg-red-400"
                    : "hidden"
            } flex items-center justify-center p-1 rounded text-white`}
        >
            <p>{message}</p>
        </div>
    );
};
